import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';

import { getBreakpointFromManor } from 'ctm-components';

import { ProviderLogo } from '../../products/products/common/provider_logo';
import { withQuoteFlatten } from '../../products/products/common/with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    container: {
        backgroundColor: theme.colors.white,
        display: 'flex',
        flexDirection: 'column',
        padding: {
            top: '1rem',
            right: '0.8rem',
            bottom: '0.4rem',
            left: '0.8rem'
        }
    },
    providerLogo: {
        width: '6.5rem',
        height: '3.9rem',
        alignSelf: 'center',
        marginBottom: theme.spacing[8]
    },
    productName: {
        alignSelf: 'center',
        textAlign: 'center',
        color: theme.colors.grey900,
        extend: ({ breakpoint }) => {
            if (breakpoint === 'xs') {
                return {
                    fontSize: theme.fontSize.xs,
                    fontWeight: theme.fontWeight.normal,
                    lineHeight: '1.8rem'
                };
            }
            return {
                fontSize: theme.fontSize.lg,
                fontWeight: theme.fontWeight.semibold,
                lineHeight: '2.2rem'
            };
        }
    }
}));

const _ProductIntroCardTitle = (props) => {
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, breakpoint });
    const { providerCode, productName, className } = props;

    return (
        <div className={classNames('test-policyComparison-productIntroCard-title', classes.container, className)}>
            <ProviderLogo className={classes.providerLogo} code={providerCode} containerSize="65x39" />
            <Typography className={classes.productName}>{productName}</Typography>
        </div>
    );
};

_ProductIntroCardTitle.propTypes = {
    className: PropTypes.string,
    quote: PropTypes.object.isRequired,

    providerCode: PropTypes.string,
    productName: PropTypes.string
};

const ProductIntroCardTitle = withQuoteFlatten(_ProductIntroCardTitle);

export { ProductIntroCardTitle };
